module.exports = __webpack_public_path__ + "static/media/arrow-card.2c401102.svg";